export default "__VITE_ASSET__B3vV8y6H__"